/* eslint-disable no-restricted-globals */

import { routeConstants } from "src/utils/constants";
import store from "src/utils/redux/store";
import { captureException } from "src/utils/sentry";
import { pushReroll, reroll, setParam } from "./utils";

declare const Android: any;

// "/"
// "/programs/health-weight/:routeId"
// "/(en|en-GB|en-AU|en-NZ|en-IE|es|de|de-DE|es-ES)/programs/health-weight/:routeId"
// "/(en|en-GB|en-AU|en-NZ|en-IE|es|de|de-DE|es-ES)"

export function isBuyflow() {
  return (
    location.pathname === "/" ||
    /^\/(en|en-GB|en-AU|en-NZ|en-IE|es|de|de-DE|es-ES)\/?/.test(
      location.pathname
    ) ||
    /(\/programs\/(health-weight|healthy-mind)\/.*)$/.test(location.pathname) ||
    /\/healthy-weight-program\//.test(location.pathname)
  );
}

function buyflowRoot(isHM: boolean, routeId = store.getState().routeId) {
  let routePath = "";
  if (
    /((?:\/programs\/(health-weight|healthy-mind)\/.*)|\/healthy-weight-program)$/.exec(
      location.pathname
    )
  ) {
    routePath = RegExp.$1;
  }
  if (
    /^\/(en|en-GB|en-AU|en-NZ|en-IE|es|de|de-DE|es-ES)(\/|$)/.exec(
      location.pathname
    )
  ) {
    return `/${RegExp.$1}${routePath}`;
  }

  // Links into buyflow
  if (!routePath && location.pathname !== "/") {
    const { language } = store.getState();
    if (routeId) {
      if (isHM) {
        if (routeId === routeConstants.direct) {
          return `/programs/healthy-mind/hm-direct`;
        }
        return `/programs/healthy-mind/${routeId}`;
      }

      return `/${language ?? "en"}/programs/health-weight/${routeId}`;
    }
  }

  return routePath || "/";
}

export const linkTo = {
  landing: buyflowRoot,
  survey(isHM: boolean, routeId?: routeConstants) {
    const landing = buyflowRoot(isHM, routeId) + location.search;
    return `${landing}#/survey`;
  },
  choosePlan(isHM: boolean) {
    const { geoLocation, userData } = store.getState();
    const queryParams = new URLSearchParams(location.search);
    // Add fcc if exists, for the in-app buyflows, in order to enforce location based on device locale.
    if (geoLocation?.is_forced_country_code) {
      setParam(queryParams, "fcc", geoLocation.country_code);
    }
    if (!isBuyflow()) {
      setParam(queryParams, "email", userData.email);
    }

    const queryParamsString = `${queryParams}` ? `?${queryParams}` : "";

    return `${buyflowRoot(isHM)}${queryParamsString}#/choosePlan`;
  },
};

export default {
  // Landing
  landing(isHM = false) {
    reroll(linkTo.landing(isHM));
  },
  // Survey
  survey(question?: string, routeId?: routeConstants) {
    let url = linkTo.survey(false, routeId);
    if (question) {
      url += `/${question}`;
    }
    pushReroll(url, isBuyflow);
  },
  hmSurvey(routeId?: routeConstants) {
    const url = linkTo.survey(true, routeId);
    pushReroll(url, isBuyflow);
  },

  choosePlan(isHM: boolean) {
    const url = linkTo.choosePlan(isHM);
    pushReroll(url, isBuyflow);
  },

  nativeBuyflowExit() {
    if ((window as any).webkit?.messageHandlers) {
      try {
        (window as any).webkit.messageHandlers.buyflowExit.postMessage({});
        return true;
      } catch (err) {
        // istanbul ignore next Error handling
        captureException(err, "nativeBuyflowExit.ios");
      }
    }
    if (typeof Android !== "undefined") {
      try {
        Android.buyflowExit();
        return true;
      } catch (err) {
        // istanbul ignore next Error handling
        captureException(err, "nativeBuyflowExit.android");
      }
    }

    // eslint-disable-next-line no-console
    console.error("nativeBuyflowExit: no message handler found");

    return false;
  },
};
